import { useAppSelector } from "../store/hooks";

export const isAllowed = (
  loaded: boolean,
  allowedKeys: string[],
  requiredKey: string,
): boolean => loaded && allowedKeys.includes(requiredKey);

/**
 * 実効能力（/auth/me の capabilities.actions）に基づく画面出し分け用フック。
 * 使い方: const can = useCan(); if (can("employee:edit")) { ...ボタン表示... }
 * ※ 防御の本体は API 側。ここは見た目の出し分けのみ。
 */
export const useCan = (): ((actionKey: string) => boolean) => {
  const capabilities = useAppSelector((state) => state.auth.capabilities);
  const loaded = useAppSelector((state) => state.auth.capabilitiesLoaded);
  // /auth/me 取得前と取得失敗時は操作を表示しない（fail-closed）。
  return (actionKey: string) => isAllowed(loaded, capabilities, actionKey);
};

/**
 * 契約オプション（機能ゲート＝軸②）に基づく出し分け用フック。
 * 照合キーは安定キーの code（OPTION_CODES）。日本語表示名でのベタ照合は禁止。
 * 使い方: const hasFeature = useHasFeature(); if (hasFeature(OPTION_CODES.ESTIMATE_AI)) { ...査定... }
 * ※ can()（ロール）とは別軸。両方満たす時だけ出す、という使い方をする。
 */
export const useHasFeature = (): ((optionCode: string) => boolean) => {
  const options = useAppSelector((state) => state.auth.optionsEnabled);
  const loaded = useAppSelector((state) => state.auth.capabilitiesLoaded);
  // /auth/me 取得前と取得失敗時は機能を表示しない（fail-closed）。
  return (optionCode: string) => isAllowed(loaded, options, optionCode);
};
